// ServiceForm.jsx - COMPLETE FIXED VERSION
// FIX: Task-based payments now properly saved with amount_paid from employee_details
// FIX: employee_details properly maintained in sync with employees array
// FIX: Amount_paid is always included when adding employees
// FIX: handleSubmit now properly builds employee_details with amount_paid

import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
import { useAuth } from '../pages/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Styles/ServUI.css";
import {
    faWrench, faUser, faPhone, faMapMarkerAlt, faCalendarAlt, faFileInvoice, faBox, faRupeeSign, faTag,
    faCar, faIdCard, faCreditCard, faMoneyBill, faPercent, faReceipt, faChevronDown, faChevronUp,
    faPlus, faMinus, faTrash, faSave, faTimes, faSpinner, faCheckCircle, faExclamationCircle,
    faExclamationTriangle, faSearch, faBarcode, faUsers, faClock, faHistory, faPrint, faEye,
    faExchangeAlt, faCopy, faFileAlt, faTrashAlt, faUserPlus, faCalendarDay, faHashtag,
    faRupeeSign as faCurrencyRupee, faCreditCard as faPayment
} from '@fortawesome/free-solid-svg-icons';

const API_BASE = 'https://ourzestapp.online/oz_backend/mechanics_module';
const SERVICE_API = `${API_BASE}/mechanics_service.php`;
const CUSTOMER_API = `${API_BASE}/mechanics_customers.php`;
const PRODUCT_API = `${API_BASE}/mechanics_products.php`;
const EMPLOYEE_API = `${API_BASE}/mechanics_employees.php`;
const CARS_API = `${API_BASE}/mechanics_cars.php`;
const SERVICESLIST_API = `${API_BASE}/mechanics_servicslist.php`;

// ----------------------- TRANSLATOR -----------------------
const createServiceTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Service Form");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'New Service': 'نیا سروس',
                'Edit Service': 'سروس میں ترمیم کریں',
                'Create and manage service requests': 'سروس کی درخواستیں بنائیں اور ان کا نظم کریں',
                'Update service details': 'سروس کی تفصیلات کو اپ ڈیٹ کریں',
                'Save': 'محفوظ کریں',
                'Saving...': 'محفوظ کر رہے ہیں...',
                'Clear': 'صاف کریں',
                'Update Service': 'سروس اپ ڈیٹ کریں',
                'Create Service': 'سروس بنائیں',
                'Service saved successfully!': 'سروس کامیابی سے محفوظ ہو گئی!',
                'Service updated successfully!': 'سروس کامیابی سے اپ ڈیٹ ہو گئی!',
                'Failed to save service': 'سروس محفوظ کرنے میں ناکامی',
                'Network error occurred': 'نیٹ ورک کی خرابی',
                'Please wait, already processing...': 'براہ کرم انتظار کریں، پہلے سے عمل میں ہے...',
                'Please fix the errors before submitting': 'براہ کرم جمع کرانے سے پہلے غلطیاں درست کریں',
                'Service name is required': 'سروس کا نام ضروری ہے',
                'Charges must be greater than 0': 'چارجز صفر سے زیادہ ہونے چاہئیں',
                'At least one service is required': 'کم از کم ایک سروس درکار ہے',
                'Walking Customer': 'واکنگ کسٹمر',
                'Search Customer': 'کسٹمر تلاش کریں',
                'Car Model': 'کار ماڈل',
                'Number Plate': 'نمبر پلیٹ',
                'Search Products': 'پروڈکٹس تلاش کریں',
                'Services Total': 'سروسز کل',
                'Products Total': 'پروڈکٹس کل',
                'Subtotal': 'ذیلی کل',
                'Discount': 'چھوٹ',
                'Grand Total': 'کل رقم',
                'Paid Amount': 'ادا کردہ رقم',
                'Balance': 'باقی رقم',
                'Payment Method': 'ادائیگی کا طریقہ',
                'Status': 'حالت',
                'Additional Notes': 'اضافی نوٹس',
                'Notes': 'نوٹس',
                'Cash': 'نقد',
                'Card': 'کارڈ',
                'Bank Transfer': 'بینک ٹرانسفر',
                'Pending': 'زیر التواء',
                'In Progress': 'جاری',
                'Completed': 'مکمل',
                'Delivered': 'ڈیلیور شدہ',
                'Cancelled': 'منسوخ',
                'Add Employee': 'ملازم شامل کریں',
                'No employees available': 'کوئی ملازم دستیاب نہیں',
                'Task Based Employees Payment': 'ٹاسک بیسڈ ملازمین کی ادائیگی',
                'Net Receivable': 'خالص قابل وصول',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Select a shop first': 'پہلے ایک شاپ منتخب کریں',
                'Shop switched successfully': 'شاپ کامیابی سے تبدیل ہو گئی',
                'Failed to switch shop': 'شاپ تبدیل کرنے میں ناکامی',
                'Current Shop': 'موجودہ شاپ',
                'Loading shops...': 'شاپس لوڈ ہو رہی ہیں...',
                'No shops available': 'کوئی شاپ دستیاب نہیں',
                'Current': 'موجودہ',
                'Save Draft': 'ڈرافٹ محفوظ کریں',
                'Drafts': 'ڈرافٹس',
                'Saved Drafts': 'محفوظ کردہ ڈرافٹس',
                'Clear Form': 'فارم صاف کریں',
                'View Drafts': 'ڈرافٹس دیکھیں',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Draft saved successfully!': 'ڈرافٹ کامیابی سے محفوظ ہو گیا!',
                'Draft loaded successfully!': 'ڈرافٹ کامیابی سے لوڈ ہو گیا!',
                'Draft deleted successfully!': 'ڈرافٹ کامیابی سے حذف ہو گیا!',
                'Cannot save empty draft': 'خالی ڈرافٹ محفوظ نہیں کر سکتے',
                'Unnamed Service': 'نامعلوم سروس',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Create Payment': 'ادائیگی بنائیں',
                'Payment Details': 'ادائیگی کی تفصیلات',
                'Close': 'بند کریں',
                'Search Car': 'کار تلاش کریں',
                'Select Car': 'کار منتخب کریں',
                'Select Service': 'سروس منتخب کریں',
                'Receipt': 'رسید',
                'Print Receipt': 'رسید پرنٹ کریں',
                'Service Number': 'سروس نمبر',
                'Time': 'وقت',
                'Cashier': 'کیشیئر',
                'Services': 'خدمات',
                'Assigned To': 'تفویض کردہ',
                'receipt': 'رسید',
                'Thank you for your business!': 'آپ کے کاروبار کا شکریہ!',
                'Powered by OurZest': 'OurZest کی طرف سے تقویت یافتہ'
            },
            'ar': {
                'New Service': 'خدمة جديدة',
                'Edit Service': 'تحرير الخدمة',
                'Create and manage service requests': 'إنشاء وإدارة طلبات الخدمة',
                'Update service details': 'تحديث تفاصيل الخدمة',
                'Save': 'حفظ',
                'Saving...': 'جاري الحفظ...',
                'Clear': 'مسح',
                'Update Service': 'تحديث الخدمة',
                'Create Service': 'إنشاء خدمة',
                'Service saved successfully!': 'تم حفظ الخدمة بنجاح!',
                'Service updated successfully!': 'تم تحديث الخدمة بنجاح!',
                'Failed to save service': 'فشل في حفظ الخدمة',
                'Network error occurred': 'حدث خطأ في الشبكة',
                'Please wait, already processing...': 'يرجى الانتظار، جاري المعالجة...',
                'Please fix the errors before submitting': 'يرجى إصلاح الأخطاء قبل الإرسال',
                'Service name is required': 'اسم الخدمة مطلوب',
                'Charges must be greater than 0': 'يجب أن تكون الرسوم أكبر من 0',
                'At least one service is required': 'مطلوب خدمة واحدة على الأقل',
                'Walking Customer': 'عميل عابر',
                'Search Customer': 'بحث عن عميل',
                'Car Model': 'موديل السيارة',
                'Number Plate': 'لوحة الأرقام',
                'Search Products': 'بحث عن منتجات',
                'Services Total': 'إجمالي الخدمات',
                'Products Total': 'إجمالي المنتجات',
                'Subtotal': 'المجموع الفرعي',
                'Discount': 'خصم',
                'Grand Total': 'المجموع الكلي',
                'Paid Amount': 'المبلغ المدفوع',
                'Balance': 'الرصيد',
                'Payment Method': 'طريقة الدفع',
                'Status': 'الحالة',
                'Additional Notes': 'ملاحظات إضافية',
                'Notes': 'ملاحظات',
                'Cash': 'نقدي',
                'Card': 'بطاقة',
                'Bank Transfer': 'تحويل بنكي',
                'Pending': 'قيد الانتظار',
                'In Progress': 'قيد التنفيذ',
                'Completed': 'مكتمل',
                'Delivered': 'تم التوصيل',
                'Cancelled': 'ملغي',
                'Add Employee': 'إضافة موظف',
                'No employees available': 'لا يوجد موظفين متاحين',
                'Task Based Employees Payment': 'دفع الموظفين على أساس المهمة',
                'Net Receivable': 'صافي المستحق',
                'Switch Shop': 'تبديل المتجر',
                'No shop selected': 'لم يتم اختيار متجر',
                'Select a shop first': 'اختر متجرًا أولاً',
                'Shop switched successfully': 'تم تبديل المتجر بنجاح',
                'Failed to switch shop': 'فشل في تبديل المتجر',
                'Current Shop': 'المتجر الحالي',
                'Loading shops...': 'جاري تحميل المتاجر...',
                'No shops available': 'لا توجد متاجر متاحة',
                'Current': 'حالي',
                'Save Draft': 'حفظ المسودة',
                'Drafts': 'المسودات',
                'Saved Drafts': 'المسودات المحفوظة',
                'Clear Form': 'مسح النموذج',
                'View Drafts': 'عرض المسودات',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Draft saved successfully!': 'تم حفظ المسودة بنجاح!',
                'Draft loaded successfully!': 'تم تحميل المسودة بنجاح!',
                'Draft deleted successfully!': 'تم حذف المسودة بنجاح!',
                'Cannot save empty draft': 'لا يمكن حفظ مسودة فارغة',
                'Unnamed Service': 'خدمة بدون اسم',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Create Payment': 'إنشاء دفعة',
                'Payment Details': 'تفاصيل الدفع',
                'Close': 'إغلاق',
                'Search Car': 'بحث عن سيارة',
                'Select Car': 'اختر سيارة',
                'Select Service': 'اختر خدمة',
                'Receipt': 'إيصال',
                'Print Receipt': 'طباعة الإيصال',
                'Service Number': 'رقم الخدمة',
                'Time': 'الوقت',
                'Cashier': 'أمين الصندوق',
                'Services': 'الخدمات',
                'Assigned To': 'مخصص ل',
                'receipt': 'إيصال',
                'Thank you for your business!': 'شكرا لتعاملكم معنا!',
                'Powered by OurZest': 'مدعوم من OurZest'
            },
            'es': {
                'New Service': 'Nuevo Servicio',
                'Edit Service': 'Editar Servicio',
                'Create and manage service requests': 'Crear y gestionar solicitudes de servicio',
                'Update service details': 'Actualizar detalles del servicio',
                'Save': 'Guardar',
                'Saving...': 'Guardando...',
                'Clear': 'Limpiar',
                'Update Service': 'Actualizar Servicio',
                'Create Service': 'Crear Servicio',
                'Service saved successfully!': '¡Servicio guardado exitosamente!',
                'Service updated successfully!': '¡Servicio actualizado exitosamente!',
                'Failed to save service': 'Error al guardar el servicio',
                'Network error occurred': 'Ocurrió un error de red',
                'Please wait, already processing...': 'Por favor espere, ya procesando...',
                'Please fix the errors before submitting': 'Por favor corrija los errores antes de enviar',
                'Service name is required': 'El nombre del servicio es requerido',
                'Charges must be greater than 0': 'Los cargos deben ser mayores a 0',
                'At least one service is required': 'Se requiere al menos un servicio',
                'Walking Customer': 'Cliente Walk-in',
                'Search Customer': 'Buscar Cliente',
                'Car Model': 'Modelo de Auto',
                'Number Plate': 'Placa',
                'Search Products': 'Buscar Productos',
                'Services Total': 'Total Servicios',
                'Products Total': 'Total Productos',
                'Subtotal': 'Subtotal',
                'Discount': 'Descuento',
                'Grand Total': 'Total General',
                'Paid Amount': 'Monto Pagado',
                'Balance': 'Saldo',
                'Payment Method': 'Método de Pago',
                'Status': 'Estado',
                'Additional Notes': 'Notas Adicionales',
                'Notes': 'Notas',
                'Cash': 'Efectivo',
                'Card': 'Tarjeta',
                'Bank Transfer': 'Transferencia Bancaria',
                'Pending': 'Pendiente',
                'In Progress': 'En Progreso',
                'Completed': 'Completado',
                'Delivered': 'Entregado',
                'Cancelled': 'Cancelado',
                'Add Employee': 'Agregar Empleado',
                'No employees available': 'No hay empleados disponibles',
                'Task Based Employees Payment': 'Pago de Empleados por Tarea',
                'Net Receivable': 'Neto por Cobrar',
                'Switch Shop': 'Cambiar Tienda',
                'No shop selected': 'No se seleccionó ninguna tienda',
                'Select a shop first': 'Seleccione una tienda primero',
                'Shop switched successfully': 'Tienda cambiada exitosamente',
                'Failed to switch shop': 'Error al cambiar de tienda',
                'Current Shop': 'Tienda Actual',
                'Loading shops...': 'Cargando tiendas...',
                'No shops available': 'No hay tiendas disponibles',
                'Current': 'Actual',
                'Save Draft': 'Guardar Borrador',
                'Drafts': 'Borradores',
                'Saved Drafts': 'Borradores Guardados',
                'Clear Form': 'Limpiar Formulario',
                'View Drafts': 'Ver Borradores',
                'No drafts saved': 'No hay borradores guardados',
                'Draft saved successfully!': '¡Borrador guardado exitosamente!',
                'Draft loaded successfully!': '¡Borrador cargado exitosamente!',
                'Draft deleted successfully!': '¡Borrador eliminado exitosamente!',
                'Cannot save empty draft': 'No se puede guardar un borrador vacío',
                'Unnamed Service': 'Servicio sin nombre',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Create Payment': 'Crear Pago',
                'Payment Details': 'Detalles de Pago',
                'Close': 'Cerrar',
                'Search Car': 'Buscar Auto',
                'Select Car': 'Seleccionar Auto',
                'Select Service': 'Seleccionar Servicio',
                'Receipt': 'Recibo',
                'Print Receipt': 'Imprimir Recibo',
                'Service Number': 'Número de Servicio',
                'Time': 'Hora',
                'Cashier': 'Cajero',
                'Services': 'Servicios',
                'Assigned To': 'Asignado a',
                'receipt': 'Recibo',
                'Thank you for your business!': '¡Gracias por su preferencia!',
                'Powered by OurZest': 'Desarrollado por OurZest'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed, trying MyMemory");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory translation failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        newService: 'New Service',
        editService: 'Edit Service',
        createDesc: 'Create and manage service requests',
        editDesc: 'Update service details',
        save: 'Save',
        saving: 'Saving...',
        clear: 'Clear',
        updateService: 'Update Service',
        createService: 'Save Service',
        serviceSaved: 'Service saved successfully!',
        serviceUpdated: 'Service updated successfully!',
        failedSave: 'Failed to save service',
        networkError: 'Network error occurred',
        pleaseWait: 'Please wait, already processing...',
        fixErrors: 'Please fix the errors before submitting',
        serviceNameRequired: 'Service name is required',
        chargesRequired: 'Charges must be greater than 0',
        atLeastOneService: 'At least one service is required',
        walkingCustomer: 'Walking Customer',
        searchCustomer: 'Search Customer',
        carModel: 'Car Model',
        numberPlate: 'Number Plate',
        searchProducts: 'Search Products',
        servicesTotal: 'Services Total',
        productsTotal: 'Products Total',
        subtotal: 'Subtotal',
        discount: 'Discount',
        grandTotal: 'Grand Total',
        paidAmount: 'Paid Amount',
        balance: 'Balance',
        paymentMethod: 'Payment Method',
        status: 'Status',
        additionalNotes: 'Additional Notes',
        notes: 'Notes',
        cash: 'Cash',
        card: 'Card',
        bankTransfer: 'Bank Transfer',
        pending: 'Pending',
        inProgress: 'In Progress',
        completed: 'Completed',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
        addEmployee: 'Add Employee',
        noEmployees: 'No employees available',
        taskBasedPayment: 'Task Based Employees Payment',
        netReceivable: 'Net Receivable',
        switchShop: 'Switch Shop',
        noShopSelected: 'No shop selected',
        selectShopFirst: 'Select a shop first',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        currentShop: 'Current Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        savedDrafts: 'Saved Drafts',
        clearForm: 'Clear Form',
        viewDrafts: 'View Drafts',
        noDraftsSaved: 'No drafts saved',
        draftSaved: 'Draft saved successfully!',
        draftLoaded: 'Draft loaded successfully!',
        draftDeleted: 'Draft deleted successfully!',
        cannotSaveEmpty: 'Cannot save empty draft',
        unnamedService: 'Unnamed Service',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        createPayment: 'Payment',
        paymentDetails: 'Payment Details',
        close: 'Close',
        searchCar: 'Search Car',
        selectCar: 'Select Car',
        selectService: 'Select Service',
        receipt: 'Receipt',
        printReceipt: 'Print Receipt',
        serviceNumber: 'Service Number',
        time: 'Time',
        cashier: 'Cashier',
        services: 'Services',
        assignedTo: 'Assigned To',
        thankYou: 'Thank you for your business!',
        poweredBy: 'Powered by OurZest'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const serviceTranslator = createServiceTranslator();

// ----------------------- TOAST NOTIFICATION -----------------------
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ----------------------- SHOP SELECTOR MODAL -----------------------
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozserui-modal-overlay" onClick={onClose}>
            <div className="ozserui-modal" onClick={e => e.stopPropagation()}>
                <div className="ozserui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozserui-modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozserui-modal-body">
                    {loading ? (
                        <div className="ozserui-loading-state">{translations.loadingShops || 'Loading shops...'}</div>
                    ) : shops.length === 0 ? (
                        <div className="ozserui-empty-state">{translations.noShops || 'No shops available'}</div>
                    ) : (
                        shops.map((shop) => (
                            <div
                                key={shop.shop_id}
                                className={`ozserui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozserui-active' : ''}`}
                                onClick={() => onSelectShop(shop)}
                            >
                                <div className="ozserui-shop-info">
                                    <div className="ozserui-shop-name">{shop.shop_name}</div>
                                    <div className="ozserui-shop-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                </div>
                                {currentShop?.shop_id === shop.shop_id && (
                                    <div className="ozserui-shop-badge">✓ {translations.current || 'Current'}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

// ----------------------- SERVICE ITEM WITH SERVICE NAME DROPDOWN (FIXED) -----------------------
const ServiceItem = ({ service, index, onUpdate, onRemove, employees, translations, errors, servicesList, loadingServices }) => {
    const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);
    const employeeRef = useRef(null);
    const [employeeSearchTerm, setEmployeeSearchTerm] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    
    const [showServiceDropdown, setShowServiceDropdown] = useState(false);
    const [serviceSearchTerm, setServiceSearchTerm] = useState('');
    const [filteredServices, setFilteredServices] = useState([]);
    
    const serviceInputRef = useRef(null);
    const serviceDropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (employeeRef.current && !employeeRef.current.contains(event.target)) {
                setShowEmployeeDropdown(false);
                setEmployeeSearchTerm('');
            }
            if (serviceDropdownRef.current && !serviceDropdownRef.current.contains(event.target) && !serviceInputRef.current?.contains(event.target)) {
                setShowServiceDropdown(false);
                setServiceSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (servicesList && servicesList.length > 0) {
            if (serviceSearchTerm.trim()) {
                const filtered = servicesList.filter(srv =>
                    srv.service_name && srv.service_name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
                );
                setFilteredServices(filtered);
                setShowServiceDropdown(filtered.length > 0);
            } else {
                setFilteredServices([]);
                setShowServiceDropdown(false);
            }
        } else {
            setFilteredServices([]);
            setShowServiceDropdown(false);
        }
    }, [serviceSearchTerm, servicesList]);

    useEffect(() => {
        if (employeeSearchTerm.trim()) {
            const filtered = employees.filter(emp =>
                !service.employees.includes(emp.employee_id) &&
                (emp.employee_name.toLowerCase().includes(employeeSearchTerm.toLowerCase()) ||
                    emp.position?.toLowerCase().includes(employeeSearchTerm.toLowerCase()))
            );
            setFilteredEmployees(filtered);
        } else {
            setFilteredEmployees(employees.filter(emp => !service.employees.includes(emp.employee_id)));
        }
    }, [employeeSearchTerm, employees, service.employees]);

    // ✅ FIX: addEmployee now includes amount_paid: 0 for task-based employees
    const addEmployee = (employeeId, employeeName, salaryType) => {
        if (!service.employees.includes(employeeId)) {
            const newEmployees = [...service.employees, employeeId];
            const newDetails = [
                ...(service.employee_details || []),
                { 
                    employee_id: employeeId, 
                    employee_name: employeeName, 
                    salary_type: salaryType, 
                    amount_paid: 0
                }
            ];
            onUpdate(index, 'employees', newEmployees, 'employee_details', newDetails);
        }
        setShowEmployeeDropdown(false);
        setEmployeeSearchTerm('');
    };

    const removeEmployee = (employeeId) => {
        const newEmployees = service.employees.filter(id => id !== employeeId);
        const newDetails = (service.employee_details || []).filter(emp => emp.employee_id !== employeeId);
        onUpdate(index, 'employees', newEmployees, 'employee_details', newDetails);
    };

    const updateEmployeePayment = (employeeId, amount) => {
        const updatedDetails = (service.employee_details || []).map(emp =>
            emp.employee_id === employeeId ? { ...emp, amount_paid: parseFloat(amount) || 0 } : emp
        );
        onUpdate(index, 'employee_details', updatedDetails);
    };

    const selectServiceFromList = (selectedService) => {
        onUpdate(index, 'service_name', selectedService.service_name);
        setShowServiceDropdown(false);
        setServiceSearchTerm('');
    };

    return (
        <div className="ozserui-service-item-row">
            <div className="ozserui-service-row-content">
                <div className={`ozserui-field ${errors?.[`service_name_${index}`] ? 'ozserui-error' : ''}`} ref={serviceDropdownRef}>
                    <div className="ozserui-input-wrapper" ref={serviceInputRef}>
                        <FontAwesomeIcon icon={faWrench} className="ozserui-input-icon" />
                        <input
                            type="text"
                            value={service.service_name}
                            onChange={(e) => {
                                onUpdate(index, 'service_name', e.target.value);
                                setServiceSearchTerm(e.target.value);
                                if (e.target.value.length > 0 && servicesList && servicesList.length > 0) {
                                    setShowServiceDropdown(true);
                                }
                            }}
                            onFocus={() => {
                                if (serviceSearchTerm.length > 0 && servicesList && servicesList.length > 0) {
                                    setShowServiceDropdown(true);
                                }
                            }}
                            placeholder=" "
                            autoComplete="off"
                        />
                        <label>Service Name <span>*</span></label>
                        {loadingServices && <FontAwesomeIcon icon={faSpinner} spin className="ozserui-search-spinner" />}
                    </div>
                    {showServiceDropdown && filteredServices && filteredServices.length > 0 && (
                        <div className="ozserui-customer-dropdown" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {filteredServices.map(srv => (
                                <div key={srv.service_id} className="ozserui-customer-item" onClick={() => selectServiceFromList(srv)}>
                                    <div className="ozserui-customer-name">{srv.service_name}</div>
                                    {srv.date && <div className="ozserui-customer-phone" style={{ fontSize: '11px' }}>Added: {srv.date}</div>}
                                </div>
                            ))}
                        </div>
                    )}
                    {errors?.[`service_name_${index}`] && <small>{errors[`service_name_${index}`]}</small>}
                </div>

                <div className={`ozserui-field ${errors?.[`charges_${index}`] ? 'ozserui-error' : ''}`}>
                    <div className="ozserui-input-wrapper">
                        <FontAwesomeIcon icon={faCurrencyRupee} className="ozserui-input-icon" />
                        <input
                            type="number"
                            value={service.charges}
                            onChange={(e) => onUpdate(index, 'charges', parseFloat(e.target.value) || 0)}
                            step="0.01"
                            min="0"
                            placeholder=" "
                        />
                        <label>Charges (Rs.) <span>*</span></label>
                    </div>
                    {errors?.[`charges_${index}`] && <small>{errors[`charges_${index}`]}</small>}
                </div>

                <div className="ozserui-field">
                    <div className="ozserui-employee-assignment-wrapper" ref={employeeRef}>
                        <div className="ozserui-assigned-employees-badges">
                            {service.employees.map(empId => {
                                const emp = employees.find(e => e.employee_id === empId);
                                const empDetail = (service.employee_details || []).find(e => e.employee_id === empId);
                                const isTaskBased = emp?.salary_type === 'task_based';
                                return emp ? (
                                    <div key={empId} className="ozserui-assigned-employee-badge">
                                        <span>{emp.employee_name}</span>
                                        {isTaskBased && (
                                            <div className="ozserui-employee-payment-input">
                                                <FontAwesomeIcon icon={faCurrencyRupee} />
                                                <input
                                                    type="number"
                                                    value={empDetail?.amount_paid || 0}
                                                    onChange={(e) => updateEmployeePayment(empId, e.target.value)}
                                                    step="0.01"
                                                    min="0"
                                                    placeholder="Amount"
                                                />
                                            </div>
                                        )}
                                        <button type="button" onClick={() => removeEmployee(empId)}>
                                            <FontAwesomeIcon icon={faTimes} size="xs" />
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </div>
                        <button
                            type="button"
                            className="ozserui-add-employee-trigger"
                            onClick={() => setShowEmployeeDropdown(!showEmployeeDropdown)}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                            <span>{translations.addEmployee || 'Add Employee'}</span>
                        </button>
                        {showEmployeeDropdown && (
                            <div className="ozserui-employee-search-dropdown">
                                <div className="ozserui-employee-search-input-wrapper">
                                    <FontAwesomeIcon icon={faSearch} className="ozserui-search-icon-small" />
                                    <input
                                        type="text"
                                        value={employeeSearchTerm}
                                        onChange={(e) => setEmployeeSearchTerm(e.target.value)}
                                        placeholder="Search employee by name or position..."
                                        autoComplete="off"
                                        className="ozserui-employee-search-input"
                                    />
                                </div>
                                <div className="ozserui-employee-dropdown-list">
                                    {filteredEmployees.length > 0 ? (
                                        filteredEmployees.map(emp => (
                                            <div
                                                key={emp.employee_id}
                                                className="ozserui-employee-dropdown-item"
                                                onClick={() => addEmployee(emp.employee_id, emp.employee_name, emp.salary_type)}
                                            >
                                                <div className="ozserui-emp-info">
                                                    <span className="ozserui-emp-name">{emp.employee_name}</span>
                                                    {emp.position && <small className="ozserui-emp-position">{emp.position}</small>}
                                                </div>
                                                <small className="ozserui-emp-salary-type">{emp.salary_type || 'N/A'}</small>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="ozserui-employee-dropdown-empty">{translations.noEmployees || 'No employees available'}</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="ozserui-service-actions-field">
                    <button type="button" className="ozserui-remove-service-icon" onClick={() => onRemove(index)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            </div>
        </div>
    );
};

// ----------------------- PRODUCT USED COMPONENT -----------------------
const ProductUsed = ({ product, index, onUpdate, onRemove, translations }) => {
    const [inputValue, setInputValue] = useState(
        product.quantity != null ? product.quantity.toString() : '1'
    );

    useEffect(() => {
        const currentNum = inputValue === '' ? 0 : parseFloat(inputValue);
        if (product.quantity !== currentNum && !isNaN(product.quantity)) {
            setInputValue(product.quantity.toString());
        }
    }, [product.quantity]);

    const handleChange = (e) => {
        const rawValue = e.target.value;
        if (rawValue === '' || rawValue === null) {
            setInputValue('0');
            onUpdate(index, 'quantity', 0);
            return;
        }
        setInputValue(rawValue);
        const numValue = parseFloat(rawValue);
        if (!isNaN(numValue)) {
            onUpdate(index, 'quantity', numValue);
        }
    };

    const handleBlur = () => {
        const numValue = parseFloat(inputValue);
        if (inputValue === '' || isNaN(numValue) || numValue < 0) {
            setInputValue('0');
            onUpdate(index, 'quantity', 0);
        } else {
            setInputValue(numValue.toString());
            onUpdate(index, 'quantity', numValue);
        }
    };

    const handleFocus = (e) => {
        e.target.select();
    };

    const price = Number(product.price_per_unit) || 0;
    const quantity = Number(product.quantity) || 0;
    const total = (price * quantity).toFixed(2);
    const themeColor = localStorage.getItem('ourzest_theme') || '#6366f1';

    return (
        <div className="ozserui-product-used-card" style={{ borderLeftColor: themeColor }}>
            <div className="ozserui-product-used-info">
                <div className="ozserui-product-name">{product.product_name}</div>
                {product.product_code && (
                    <div className="ozserui-product-code">{product.product_code}</div>
                )}
                {product.batch_no && (
                    <div className="ozserui-batch-info">#{product.batch_no}</div>
                )}
            </div>
            <div className="ozserui-product-used-details">
                <div className="ozserui-form-group ozserui-small">
                    <label>Qty</label>
                    <input
                        type="number"
                        value={inputValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        step="0.001"
                        min="0"
                    />
                    <span className="ozserui-unit-badge">{product.unit || 'units'}</span>
                </div>
                <div className="ozserui-form-group ozserui-small">
                    <label>Rs./Unit</label>
                    <input
                        type="number"
                        value={product.price_per_unit}
                        readOnly
                    />
                </div>
                <div className="ozserui-product-total">
                    Rs. {total}
                </div>
                <button type="button" className="ozserui-remove-product-btn" onClick={() => onRemove(index)}>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </div>
        </div>
    );
};

// ----------------------- FINANCIAL SUMMARY -----------------------
const FinancialSummaryContent = memo(({ services, selectedProducts, formData, taskBasedTotal, netReceivable, translations, handleChange }) => (
    <>
        <div className="ozserui-summary-row">
            <span>{translations.servicesTotal || 'Services Total'}:</span>
            <span>Rs. {services.reduce((sum, s) => sum + (s.charges || 0), 0).toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.productsTotal || 'Products Total'}:</span>
            <span>Rs. {selectedProducts.reduce((sum, p) => sum + ((Number(p.price_per_unit) || 0) * (Number(p.quantity) || 0)), 0).toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.subtotal || 'Subtotal'}:</span>
            <span>Rs. {formData.subtotal.toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.discount || 'Discount'} (Rs.):</span>
            <input type="number" name="discount" value={formData.discount} onChange={handleChange} step="0.01" min="0" />
        </div>

        {taskBasedTotal > 0 && (
            <>
                <div className="ozserui-summary-row">
                    <span>{translations.taskBasedPayment || 'Task Based Employees Payment'}:</span>
                    <span className="ozserui-task-based-amount">- Rs. {taskBasedTotal.toFixed(2)}</span>
                </div>
                <div className="ozserui-summary-row ozserui-net-receivable">
                    <span>{translations.netReceivable || 'Net Receivable'}:</span>
                    <span className="ozserui-net-amount">Rs. {netReceivable.toFixed(2)}</span>
                </div>
            </>
        )}

        <div className="ozserui-summary-row ozserui-grand-total">
            <span>{translations.grandTotal || 'Grand Total'}:</span>
            <span>Rs. {formData.grand_total.toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.paidAmount || 'Paid Amount'} (Rs.):</span>
            <input type="number" name="paid_amount" value={formData.paid_amount} onChange={handleChange} step="0.01" min="0" max={formData.grand_total} />
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.balance || 'Balance'}:</span>
            <span className={formData.balance > 0 ? 'ozserui-balance-due' : 'ozserui-balance-zero'}>Rs. {formData.balance.toFixed(2)}</span>
        </div>
    </>
));

// ----------------------- PAYMENT MODAL -----------------------
const PaymentModal = memo(({ showPaymentModal, setShowPaymentModal, translations, services, selectedProducts, formData, taskBasedTotal, netReceivable, handleChange }) => {
    if (!showPaymentModal) return null;
    
    return (
        <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
            <div 
                className="ozlistui-modal-content ozlistui-edit-modal-content" 
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '550px',
                    maxWidth: '90vw',
                    maxHeight: '85vh'
                }}
            >
                <div className="ozlistui-modal-header">
                    <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faPayment} /></div>
                    <div className="ozlistui-modal-title">
                        <h3>{translations.paymentDetails || 'Payment Details'}</h3>
                    </div>
                    <button className="ozlistui-close-btn" onClick={() => setShowPaymentModal(false)}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <div className="ozlistui-modal-body">
                    <div className="ozserui-financial-summary" style={{ padding: 0 }}>
                        <FinancialSummaryContent 
                            services={services}
                            selectedProducts={selectedProducts}
                            formData={formData}
                            taskBasedTotal={taskBasedTotal}
                            netReceivable={netReceivable}
                            translations={translations}
                            handleChange={handleChange}
                        />
                    </div>
                </div>
                
                <div className="ozlistui-modal-footer">
                    <button 
                        type="button" 
                        className="ozlistui-btn ozlistui-btn-secondary" 
                        onClick={() => setShowPaymentModal(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                        {translations.close || 'Close'}
                    </button>
                </div>
            </div>
        </div>
    );
});

// ----------------------- MAIN SERVICE FORM COMPONENT -----------------------
const ServiceForm = ({ serviceId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [shopId, setShopId] = useState(() => {
        if (user?.shop_id) return user.shop_id;
        return localStorage.getItem('current_shop_id') || '';
    });

    const [translations, setTranslations] = useState({});
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('ourzest_darkMode') === 'true');
    const [currentThemeColor, setCurrentThemeColor] = useState(() => localStorage.getItem('ourzest_theme') || '#6366f1');
    const [currentLanguage, setCurrentLanguage] = useState(() => localStorage.getItem('ourzest_language') || 'en');

    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    const draftsDropdownRef = useRef(null);

    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [customerSearchTerm, setCustomerSearchTerm] = useState('');
    const [searchingCustomer, setSearchingCustomer] = useState(false);

    const [employees, setEmployees] = useState([]);

    const [products, setProducts] = useState([]);
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [searchingProduct, setSearchingProduct] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [services, setServices] = useState([
        { serial_no: 1, service_name: '', charges: 0, description: '', employees: [], employee_details: [] }
    ]);

    const [cars, setCars] = useState([]);
    const [carSearchTerm, setCarSearchTerm] = useState('');
    const [showCarDropdown, setShowCarDropdown] = useState(false);
    const [searchingCar, setSearchingCar] = useState(false);
    const carSearchRef = useRef(null);

    const [servicesList, setServicesList] = useState([]);
    const [searchingServicesList, setSearchingServicesList] = useState(false);

    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        businessaddress: '',
        phonenumber: '',
        gst_number: '',
        email: '',
        bussinesslogo: '',
        bussinesslogo_url: ''
    });

    const [showPaymentMethodDropdown, setShowPaymentMethodDropdown] = useState(false);
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const paymentMethodRef = useRef(null);
    const statusRef = useRef(null);

    const [showPaymentModal, setShowPaymentModal] = useState(false);

    const customerSearchInputRef = useRef(null);

    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        service_number: '',
        car_model: '',
        car_number_plate: '',
        subtotal: 0,
        tax: 0,
        discount: 0,
        grand_total: 0,
        paid_amount: 0,
        balance: 0,
        payment_method: 'cash',
        status: 'completed',
        notes: '',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    });

    const paymentMethods = [
        { value: 'cash', label: 'Cash' },
        { value: 'card', label: 'Card' },
        { value: 'bank_transfer', label: 'Bank Transfer' }
    ];

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const customerSearchRef = useRef(null);
    const productSearchRef = useRef(null);
    const isSavingRef = useRef(false);

    // Tab key handler to close all dropdowns
    useEffect(() => {
        const handleTabKey = (e) => {
            if (e.key === 'Tab') {
                setShowCustomerDropdown(false);
                setShowProductDropdown(false);
                setShowCarDropdown(false);
                setShowPaymentMethodDropdown(false);
                setShowStatusDropdown(false);
                setShowDraftsList(false);
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return () => document.removeEventListener('keydown', handleTabKey);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (customerSearchInputRef.current) {
                customerSearchInputRef.current.focus();
            }
        }, 100);
    }, []);

    // Load cars from API
    const loadCars = async () => {
        if (!currentShop?.shop_id) {
            console.log('No shop selected, cannot load cars');
            return;
        }
        
        setSearchingCar(true);
        try {
            console.log('Loading cars for shop:', currentShop.shop_id);
            const response = await fetch(CARS_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    action: 'get_cars', 
                    shop_id: currentShop.shop_id,
                    limit: 100
                })
            });
            const data = await response.json();
            console.log('Cars API response:', data);
            if (data.status === 'success') {
                setCars(data.data || []);
            } else {
                console.error('Error loading cars:', data.message);
            }
        } catch (error) {
            console.error('Error loading cars:', error);
        } finally {
            setSearchingCar(false);
        }
    };

    // Search cars
    const searchCars = async (searchTerm) => {
        if (!currentShop?.shop_id) {
            console.log('No shop selected, cannot search cars');
            return;
        }
        
        if (!searchTerm || searchTerm.length < 2) {
            loadCars();
            return;
        }
        
        setSearchingCar(true);
        try {
            console.log('Searching cars for term:', searchTerm);
            const response = await fetch(CARS_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    action: 'search_cars', 
                    shop_id: currentShop.shop_id,
                    search_term: searchTerm
                })
            });
            const data = await response.json();
            console.log('Car search response:', data);
            if (data.status === 'success') {
                setCars(data.data || []);
                setShowCarDropdown(data.data && data.data.length > 0);
            }
        } catch (error) {
            console.error('Error searching cars:', error);
        } finally {
            setSearchingCar(false);
        }
    };

    // Load services list from API
    const loadServicesList = async () => {
        if (!currentShop?.shop_id) return;
        
        setSearchingServicesList(true);
        try {
            const response = await fetch(SERVICESLIST_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    action: 'get_services', 
                    shop_id: currentShop.shop_id,
                    limit: 100
                })
            });
            const data = await response.json();
            console.log('Services list API response:', data);
            if (data.status === 'success') {
                setServicesList(data.data || []);
            }
        } catch (error) {
            console.error('Error loading services list:', error);
        } finally {
            setSearchingServicesList(false);
        }
    };

    // Select car from dropdown
    const selectCar = (car) => {
        setFormData(prev => ({ ...prev, car_model: car.car_name }));
        setCarSearchTerm(car.car_name);
        setShowCarDropdown(false);
    };

    // Fetch business info for receipt
    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_business_info&username=' + encodeURIComponent(user.username), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const data = await response.json();
            if (data.status === 'success') {
                setBusinessInfo({
                    businessname: data.businessname || '',
                    businessaddress: data.businessaddress || '',
                    phonenumber: data.phonenumber || '',
                    gst_number: data.gst_number || '',
                    email: data.email || '',
                    bussinesslogo: data.bussinesslogo || '',
                    bussinesslogo_url: data.bussinesslogo_url || ''
                });
            } else {
                setBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    businessaddress: user.business_address || '',
                    phonenumber: user.phonenumber || '',
                    gst_number: user.gst_number || '',
                    email: user.email || '',
                    bussinesslogo: user.bussinesslogo || '',
                    bussinesslogo_url: user.bussinesslogo_url || ''
                });
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            setBusinessInfo({
                businessname: user.business_name || user.fullname || '',
                businessaddress: user.business_address || '',
                phonenumber: user.phonenumber || '',
                gst_number: user.gst_number || '',
                email: user.email || '',
                bussinesslogo: user.bussinesslogo || '',
                bussinesslogo_url: user.bussinesslogo_url || ''
            });
        }
    }, [user]);

    // Direct Print Function
    const handleDirectPrint = () => {
        const printWindow = window.open('', '_blank');
        
        if (printWindow) {
            const shopName = businessInfo?.businessname || currentShop?.shop_name || 'Shop Name';
            const shopAddress = businessInfo?.businessaddress || '';
            const shopPhone = businessInfo?.phonenumber || '';
            const businessEmail = businessInfo?.email || '';
            const gstNumber = businessInfo?.gst_number || '';
            const businessLogo = businessInfo?.bussinesslogo_url || businessInfo?.bussinesslogo || '';
            
            const formatCurrency = (amount) => {
                if (!amount && amount !== 0) return 'Rs. 0.00';
                return `Rs. ${parseFloat(amount).toFixed(2)}`;
            };
            
            const formatDate = (dateString) => {
                if (!dateString) return '';
                const date = new Date(dateString);
                return date.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
            };
            
            const servicesTotal = services.reduce((sum, s) => sum + (s.charges || 0), 0);
            const productsTotal = selectedProducts.reduce((sum, p) => sum + ((Number(p.price_per_unit) || 0) * (Number(p.quantity) || 0)), 0);
            const taskBasedTotalVal = calculateTaskBasedEmployeeTotal();
            
            const escapeHtml = (text) => {
                if (!text) return '';
                return String(text).replace(/[&<>]/g, function(m) {
                    if (m === '&') return '&amp;';
                    if (m === '<') return '&lt;';
                    if (m === '>') return '&gt;';
                    return m;
                });
            };
            
            const customerName = selectedCustomer?.customer_name || 'Walk-in Customer';
            
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Service Receipt ${formData.service_number}</title>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <style>
                        @page { size: auto; margin: 12mm; }
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: 'Segoe UI', Arial, sans-serif; background: white; color: #1f2937; font-size: 10pt; line-height: 1.4; }
                        .receipt-container { max-width: 100%; margin: 0 auto; padding: 0; }
                        .text-center { text-align: center; }
                        .text-right { text-align: right; }
                        .text-left { text-align: left; }
                        .font-bold { font-weight: bold; }
                        
                        .header {
                            display: flex;
                            align-items: flex-start;
                            justify-content: space-between;
                            padding-bottom: 12px;
                            border-bottom: 2px solid #e5e7eb;
                            margin-bottom: 15px;
                        }
                        .header-left { display: flex; align-items: center; gap: 15px; flex: 1; }
                        .header-logo-wrapper { flex-shrink: 0; }
                        .header-logo { max-height: 70px; max-width: 100px; width: auto; height: auto; object-fit: contain; display: block; }
                        .header-info { flex: 1; min-width: 0; }
                        .business-name { font-size: 18pt; font-weight: 700; color: #1f2937; letter-spacing: 0.5px; word-break: break-word; line-height: 1.2; }
                        .business-address { font-size: 9pt; color: #6b7280; margin-top: 2px; word-break: break-word; line-height: 1.4; }
                        .business-contact { display: flex; align-items: center; gap: 15px; flex-wrap: wrap; margin-top: 2px; font-size: 9pt; color: #6b7280; }
                        .business-gst { font-size: 8pt; color: #9ca3af; margin-top: 1px; }
                        
                        .header-right { text-align: right; flex-shrink: 0; margin-left: 20px; }
                        .header-right .receipt-label { font-size: 16pt; font-weight: 700; text-transform: uppercase; letter-spacing: 3px; color: #1f2937; }
                        .header-right .customer-info-label { font-size: 10pt; color: #4b5563; margin-top: 4px; font-weight: 500; }
                        .header-right .customer-info-label span { font-weight: 600; color: #1f2937; }
                        
                        .bill-info {
                            display: flex;
                            justify-content: space-between;
                            font-size: 10pt;
                            margin: 4px 0;
                            padding: 3px 0;
                            flex-wrap: wrap;
                            gap: 5px;
                        }
                        .bill-info .label { font-weight: 600; color: #4b5563; }
                        .bill-info .value { font-weight: 500; }
                        
                        .items-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 12px 0;
                            border: 1px solid #d1d5db;
                        }
                        .items-table th {
                            background: #f3f4f6;
                            text-align: left;
                            padding: 10px 8px;
                            font-size: 9pt;
                            font-weight: 600;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                            color: #374151;
                            border: 1px solid #d1d5db;
                        }
                        .items-table td {
                            padding: 8px 8px;
                            font-size: 10pt;
                            vertical-align: top;
                            border: 1px solid #d1d5db;
                        }
                        .items-table th:last-child,
                        .items-table td:last-child { text-align: right; }
                        .items-table th:nth-child(3),
                        .items-table td:nth-child(3) { text-align: center; }
                        .items-table th:nth-child(1),
                        .items-table td:nth-child(1) { text-align: center; }
                        .items-table .product-name { font-weight: 500; word-break: break-word; }
                        .items-table .product-meta { font-size: 8pt; color: #9ca3af; display: block; }
                        .service-table td:last-child { text-align: right; }
                        .service-table .service-name-cell { font-weight: 500; }
                        
                        .payment-section {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 10px;
                            padding-top: 5px;
                            border-top: 1px solid #e5e7eb;
                        }
                        .payment-box { width: 280px; }
                        .payment-row {
                            display: flex;
                            justify-content: space-between;
                            padding: 4px 0;
                            font-size: 10.5pt;
                        }
                        .payment-row .label { color: #4b5563; font-weight: 500; }
                        .payment-row .value { font-weight: 500; }
                        .payment-row.total {
                            font-weight: 700;
                            font-size: 13pt;
                            padding-top: 8px;
                            border-top: 2px solid #1f2937;
                            margin-top: 4px;
                        }
                        .payment-row.total .label { color: #1f2937; }
                        .payment-row.total .value { color: #059669; }
                        .payment-row .value.text-danger { color: #dc2626; }
                        .payment-row .value.text-primary { color: #3b82f6; }
                        .payment-row .value.text-warning { color: #d97706; }
                        .payment-row .value.text-success { color: #059669; }
                        
                        .payment-method-box {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 6px;
                            gap: 12px;
                            font-size: 9pt;
                            color: #6b7280;
                        }
                        .payment-method-box .badge {
                            display: inline-block;
                            background: #f3f4f6;
                            padding: 3px 12px;
                            border-radius: 4px;
                            font-weight: 600;
                            font-size: 9pt;
                            color: #374151;
                        }
                        
                        .footer {
                            text-align: center;
                            font-size: 8pt;
                            margin-top: 15px;
                            padding-top: 10px;
                            border-top: 1px solid #e5e7eb;
                            color: #9ca3af;
                        }
                        .footer .thankyou { font-size: 11pt; color: #4b5563; font-weight: 500; }
                        .notes-box {
                            background: #f9fafb;
                            padding: 8px 12px;
                            border-radius: 6px;
                            font-size: 9pt;
                            color: #4b5563;
                            margin-top: 10px;
                            border-left: 4px solid #9ca3af;
                            word-break: break-word;
                        }
                        
                        @media print { body { margin: 0; } .no-print { display: none; } }
                        @media print and (max-width: 160mm) {
                            body { font-size: 9pt; }
                            .business-name { font-size: 14pt; }
                            .header-right .receipt-label { font-size: 13pt; }
                            .items-table th, .items-table td { font-size: 8.5pt; padding: 6px 6px; }
                            .payment-box { width: 230px; }
                            .payment-row { font-size: 9pt; }
                            .payment-row.total { font-size: 11pt; }
                            .header-logo { max-height: 50px; max-width: 80px; }
                        }
                    </style>
                </head>
                <body>
                    <div class="receipt-container">
                        <div class="header">
                            <div class="header-left">
                                ${businessLogo ? `
                                <div class="header-logo-wrapper">
                                    <img src="${businessLogo}" alt="${escapeHtml(shopName)}" class="header-logo" onerror="this.style.display='none'" />
                                </div>` : ''}
                                <div class="header-info">
                                    <div class="business-name">${escapeHtml(shopName)}</div>
                                    ${shopAddress ? `<div class="business-address">${escapeHtml(shopAddress)}</div>` : ''}
                                    ${(shopPhone || businessEmail) ? `
                                    <div class="business-contact">
                                        ${shopPhone ? `<span>📞 ${escapeHtml(shopPhone)}</span>` : ''}
                                        ${businessEmail ? `<span>✉ ${escapeHtml(businessEmail)}</span>` : ''}
                                    </div>` : ''}
                                    ${gstNumber ? `<div class="business-gst">GST: ${escapeHtml(gstNumber)}</div>` : ''}
                                </div>
                            </div>
                            <div class="header-right">
                                <div class="receipt-label">${translations.receipt || 'SERVICE RECEIPT'}</div>
                                <div class="customer-info-label">${translations.customer || 'Customer'}: <span>${escapeHtml(customerName)}</span></div>
                            </div>
                        </div>
                        
                        <div class="bill-info">
                            <span><span class="label">${translations.date || 'Date'}:</span> <span class="value">${formatDate(formData.date)}</span></span>
                            <span><span class="label">${translations.carModel || 'Car Model'}:</span> <span class="value">${escapeHtml(formData.car_model || '—')}</span></span>
                            <span><span class="label">${translations.numberPlate || 'Number Plate'}:</span> <span class="value">${escapeHtml(formData.car_number_plate || '—')}</span></span>
                        </div>
                        
                        ${services.filter(s => s.service_name).length > 0 ? `
                        <table class="items-table service-table">
                            <thead>
                                <tr>
                                    <th style="width:8%;">#</th>
                                    <th style="width:67%;">${translations.services || 'Service'}</th>
                                    <th style="width:25%;">${translations.charges || 'Charges'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${services.filter(s => s.service_name).map((service, idx) => `
                                <tr>
                                    <td>${idx + 1}</td>
                                    <td>
                                        <div class="service-name-cell">${escapeHtml(service.service_name)}</div>
                                        ${service.description ? `<div class="product-meta">${escapeHtml(service.description)}</div>` : ''}
                                    </td>
                                    <td>${formatCurrency(service.charges)}</td>
                                </tr>
                                `).join('')}
                            </tbody>
                        </table>
                        ` : ''}
                        
                        ${selectedProducts.length > 0 ? `
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th style="width:8%;">#</th>
                                    <th style="width:37%;">${translations.productName || 'Product'}</th>
                                    <th style="width:15%;">${translations.quantity || 'Qty'}</th>
                                    <th style="width:18%;">${translations.price || 'Price'}</th>
                                    <th style="width:22%;">${translations.total || 'Total'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${selectedProducts.map((product, idx) => `
                                <tr>
                                    <td>${idx + 1}</td>
                                    <td>
                                        <div class="product-name">${escapeHtml(product.product_name)}</div>
                                    </td>
                                    <td>${parseFloat(product.quantity).toFixed(2)} ${product.unit || ''}</td>
                                    <td>${formatCurrency(product.price_per_unit)}</td>
                                    <td>${formatCurrency(product.price_per_unit * product.quantity)}</td>
                                </tr>
                                `).join('')}
                            </tbody>
                        </table>
                        ` : ''}
                        
                        <div class="payment-section">
                            <div class="payment-box">
                                ${services.filter(s => s.service_name).length > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.servicesTotal || 'Services Total'}</span>
                                    <span class="value">${formatCurrency(servicesTotal)}</span>
                                </div>` : ''}
                                ${selectedProducts.length > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.productsTotal || 'Products Total'}</span>
                                    <span class="value">${formatCurrency(productsTotal)}</span>
                                </div>` : ''}
                                <div class="payment-row">
                                    <span class="label">${translations.subtotal || 'Subtotal'}</span>
                                    <span class="value">${formatCurrency(formData.subtotal)}</span>
                                </div>
                                ${parseFloat(formData.discount) > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.discount || 'Discount'}</span>
                                    <span class="value text-danger">-${formatCurrency(formData.discount)}</span>
                                </div>` : ''}
                                ${parseFloat(formData.tax) > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.tax || 'Tax'}</span>
                                    <span class="value">${formatCurrency(formData.tax)}</span>
                                </div>` : ''}
                                ${taskBasedTotalVal > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.taskBasedPayment || 'Task Based Payment'}</span>
                                    <span class="value text-danger">-${formatCurrency(taskBasedTotalVal)}</span>
                                </div>` : ''}
                                <div class="payment-row total">
                                    <span class="label">${translations.grandTotal || 'GRAND TOTAL'}</span>
                                    <span class="value">${formatCurrency(formData.grand_total)}</span>
                                </div>
                                ${parseFloat(formData.paid_amount) > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.paidAmount || 'Paid'}</span>
                                    <span class="value text-primary">${formatCurrency(formData.paid_amount)}</span>
                                </div>` : ''}
                                ${parseFloat(formData.balance) > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.balance || 'Balance Due'}</span>
                                    <span class="value text-warning">${formatCurrency(formData.balance)}</span>
                                </div>` : ''}
                                ${parseFloat(formData.balance) <= 0 && parseFloat(formData.paid_amount) > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.balance || 'Balance'}</span>
                                    <span class="value text-success">${formatCurrency(formData.balance)}</span>
                                </div>` : ''}
                            </div>
                        </div>
                        
                        <div class="payment-method-box">
                            <span>${translations.paymentMethod || 'Payment Method'}: <span class="badge">${formData.payment_method || 'Cash'}</span></span>
                            <span>${translations.status || 'Status'}: <span class="badge">${formData.status || 'Completed'}</span></span>
                        </div>
                        
                        ${formData.notes ? `
                        <div class="notes-box">
                            <strong>${translations.notes || 'Notes'}:</strong> ${escapeHtml(formData.notes)}
                        </div>` : ''}
                        
                        <div class="footer">
                            <div class="thankyou">${translations.thankYou || 'Thank you for your business!'}</div>
                            <div>${translations.poweredBy || 'Powered by OurZest'}</div>
                        </div>
                    </div>
                    <script>
                    window.onload = function() {
                        setTimeout(function() {
                            window.print();
                            window.onafterprint = function() { window.close(); };
                        }, 500);
                    };
                    <\/script>
                </body>
                </html>
            `);
            
            printWindow.document.close();
            printWindow.focus();
        }
    };

    // Draft Management Functions
    const saveDraft = () => {
        const draftData = {
            formData,
            services,
            selectedProducts,
            selectedCustomer,
            customerSearchTerm,
            carSearchTerm,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        if (!formData.service_number && services.length === 1 && !services[0].service_name && selectedProducts.length === 0) {
            showToast('warning', translations.cannotSaveEmpty || 'Cannot save empty draft');
            return;
        }

        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...draftData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        const existingDrafts = JSON.parse(localStorage.getItem('service_drafts') || '[]');
        existingDrafts.unshift(draft);
        const limitedDrafts = existingDrafts.slice(0, 20);
        localStorage.setItem('service_drafts', JSON.stringify(limitedDrafts));

        showToast('success', translations.draftSaved || 'Draft saved successfully!');
        loadDrafts();
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('service_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
    };

    const loadDraft = (draft) => {
        setFormData(draft.formData || {
            date: new Date().toISOString().split('T')[0],
            service_number: '',
            car_model: '',
            car_number_plate: '',
            subtotal: 0,
            tax: 0,
            discount: 0,
            grand_total: 0,
            paid_amount: 0,
            balance: 0,
            payment_method: 'cash',
            status: 'completed',
            notes: ''
        });
        setServices(draft.services || [{ serial_no: 1, service_name: '', charges: 0, description: '', employees: [], employee_details: [] }]);
        setSelectedProducts(draft.selectedProducts || []);
        setSelectedCustomer(draft.selectedCustomer || null);
        setCustomerSearchTerm(draft.customerSearchTerm || '');
        setCarSearchTerm(draft.carSearchTerm || '');
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
        
        setTimeout(() => {
            if (customerSearchInputRef.current) {
                customerSearchInputRef.current.focus();
            }
        }, 100);
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('service_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('service_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', translations.draftDeleted || 'Draft deleted successfully!');
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    useEffect(() => {
        if (showDraftsList && draftsDropdownRef.current) {
            const button = draftsDropdownRef.current.querySelector('.drafts-btn');
            const dropdown = draftsDropdownRef.current.querySelector('.ozui-drafts-dropdown');

            if (button && dropdown) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = `${rect.bottom + 8}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
            }
        }
    }, [showDraftsList]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
            if (carSearchRef.current && !carSearchRef.current.contains(event.target)) {
                setShowCarDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (paymentMethodRef.current && !paymentMethodRef.current.contains(event.target)) {
                setShowPaymentMethodDropdown(false);
            }
            if (statusRef.current && !statusRef.current.contains(event.target)) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Theme color sync
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }

        document.documentElement.style.setProperty('--ozserui-primary', color);
        document.documentElement.style.setProperty('--ozserui-primary-dark', color);
        document.documentElement.style.setProperty('--ozserui-primary-light', color);

        let style = document.getElementById('dynamic-orb-styles-service');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles-service';
            document.head.appendChild(style);
        }

        style.textContent = `
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
        `;

        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                applyTheme(e.newValue || '#6366f1');
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
        };
    }, [applyTheme]);

    // Dark mode sync
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.ozserui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozserui-dark');
                } else {
                    container.classList.remove('ozserui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozserui-dark');
                document.documentElement.classList.add('ozserui-dark');
            } else {
                document.body.classList.remove('ozserui-dark');
                document.documentElement.classList.remove('ozserui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') syncDarkMode();
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozserui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozserui-dark');
                    } else {
                        container.classList.remove('ozserui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozserui-dark');
                    document.documentElement.classList.add('ozserui-dark');
                } else {
                    document.body.classList.remove('ozserui-dark');
                    document.documentElement.classList.remove('ozserui-dark');
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    // Language sync
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await serviceTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
        };
    }, [currentLanguage]);

    // RTL direction sync
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozserui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozserui-rtl');
                container.classList.remove('ozserui-ltr');
            } else {
                container.classList.add('ozserui-ltr');
                container.classList.remove('ozserui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    const showToast = (type, message) => {
        setToast({ show: true, type, message });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 3000);
    };

    const loadEmployees = async () => {
        if (!shopId) return;
        try {
            const response = await fetch(EMPLOYEE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_records', shop_id: shopId, status: 'active' })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setEmployees(data.data || []);
            }
        } catch (error) {
            console.error('Error loading employees:', error);
        }
    };

    const searchCustomers = async (searchTerm) => {
        if (!shopId) return;
        setSearchingCustomer(true);
        try {
            const response = await fetch(SERVICE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_customers', shop_id: shopId, search_term: searchTerm })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCustomers(data.data || []);
                setShowCustomerDropdown(data.data.length > 0);
            }
        } catch (error) {
            console.error('Error searching customers:', error);
        } finally {
            setSearchingCustomer(false);
        }
    };

    const searchProducts = async (searchTerm) => {
        if (!shopId || searchTerm.length < 2) {
            setProducts([]);
            setShowProductDropdown(false);
            return;
        }
        setSearchingProduct(true);
        try {
            const response = await fetch(SERVICE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_products', shop_id: shopId, search_term: searchTerm })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setProducts(data.data || []);
                setShowProductDropdown(data.data.length > 0);
            }
        } catch (error) {
            console.error('Error searching products:', error);
        } finally {
            setSearchingProduct(false);
        }
    };

    const selectCustomer = (customer) => {
        setSelectedCustomer(customer);
        setCustomerSearchTerm(customer.customer_name);
        setShowCustomerDropdown(false);
    };

    const selectProduct = (product) => {
        const existingIndex = selectedProducts.findIndex(p => p.product_id === product.id);
        const pricePerUnit = Number(product.sell_price_per_unit || product.sell_price) || 0;

        if (existingIndex >= 0) {
            setSelectedProducts(prev =>
                prev.map((p, i) =>
                    i === existingIndex ? { ...p, quantity: (p.quantity || 0) + 1 } : p
                )
            );
        } else {
            setSelectedProducts([
                ...selectedProducts,
                {
                    product_id: product.id,
                    product_name: product.product_name,
                    product_code: product.product_code,
                    batch_no: product.batch_no,
                    quantity: 1,
                    unit: product.sub_packing_type || product.unit_of_measure || 'piece',
                    unit_of_measure: product.unit_of_measure,
                    packing_type: product.packing_type,
                    items_per_pack: product.items_per_pack || 1,
                    price_per_unit: pricePerUnit
                }
            ]);
        }
        setProductSearchTerm('');
        setShowProductDropdown(false);
        showToast('success', `${product.product_name} added to products used`);
    };

    const updateProductQuantity = (index, quantity) => {
        setSelectedProducts(prev =>
            prev.map((p, i) =>
                i === index ? { ...p, quantity: quantity } : p
            )
        );
    };

    const removeProduct = (index) => {
        setSelectedProducts(prev => prev.filter((_, i) => i !== index));
    };

    const addService = () => {
        setServices([
            ...services,
            { serial_no: services.length + 1, service_name: '', charges: 0, description: '', employees: [], employee_details: [] }
        ]);
    };

    // ✅ FIX: updateService now ensures employee_details stays in sync
    const updateService = (index, ...fieldValuePairs) => {
        setServices(prevServices => {
            const updated = [...prevServices];
            const serviceCopy = { ...updated[index] };
            for (let i = 0; i < fieldValuePairs.length; i += 2) {
                const field = fieldValuePairs[i];
                const value = fieldValuePairs[i + 1];
                serviceCopy[field] = value;
            }
            // ✅ Ensure employee_details stays in sync with employees
            if (fieldValuePairs.includes('employees')) {
                const employeesIdx = fieldValuePairs.indexOf('employees');
                const newEmployees = fieldValuePairs[employeesIdx + 1];
                const currentDetails = serviceCopy.employee_details || [];
                
                newEmployees.forEach(empId => {
                    if (!currentDetails.find(d => d.employee_id === empId)) {
                        const emp = employees.find(e => e.employee_id === empId);
                        currentDetails.push({
                            employee_id: empId,
                            employee_name: emp?.employee_name || '',
                            salary_type: emp?.salary_type || 'task_based',
                            amount_paid: 0
                        });
                    }
                });
                serviceCopy.employee_details = currentDetails.filter(d => newEmployees.includes(d.employee_id));
            }
            updated[index] = serviceCopy;
            return updated;
        });
    };

    const removeService = (index) => {
        if (services.length > 1) {
            setServices(services.filter((_, i) => i !== index));
        }
    };

    const calculateTaskBasedEmployeeTotal = () => {
        let total = 0;
        services.forEach(service => {
            (service.employee_details || []).forEach(emp => {
                const empData = employees.find(e => e.employee_id === emp.employee_id);
                if (empData?.salary_type === 'task_based') {
                    total += parseFloat(emp.amount_paid) || 0;
                }
            });
        });
        return total;
    };

    const calculateTotals = useCallback(() => {
        const servicesTotal = services.reduce((sum, service) => sum + (service.charges || 0), 0);
        const productsTotal = selectedProducts.reduce((sum, product) => sum + ((Number(product.price_per_unit) || 0) * (Number(product.quantity) || 0)), 0);
        const subtotal = servicesTotal + productsTotal;
        const tax = parseFloat(formData.tax) || 0;
        const discount = parseFloat(formData.discount) || 0;
        const grandTotal = subtotal + tax - discount;
        const paid = parseFloat(formData.paid_amount) || 0;
        const balance = grandTotal - paid;

        setFormData(prev => ({ ...prev, subtotal, grand_total: grandTotal, balance }));
    }, [services, selectedProducts, formData.tax, formData.discount, formData.paid_amount]);

    useEffect(() => {
        calculateTotals();
    }, [services, selectedProducts, formData.tax, formData.discount, calculateTotals]);

    const loadServiceData = async (id) => {
        if (!shopId) return;
        setLoading(true);
        try {
            const response = await fetch(SERVICE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_record', service_id: id, shop_id: shopId })
            });
            const data = await response.json();
            if (data.status === 'success') {
                const service = data.data;
                setFormData(prev => ({
                    ...prev,
                    date: service.date || new Date().toISOString().split('T')[0],
                    service_number: service.service_number || '',
                    car_model: service.car_model || '',
                    car_number_plate: service.car_number_plate || '',
                    subtotal: parseFloat(service.subtotal) || 0,
                    tax: parseFloat(service.tax) || 0,
                    discount: parseFloat(service.discount) || 0,
                    grand_total: parseFloat(service.grand_total) || 0,
                    paid_amount: parseFloat(service.paid_amount) || 0,
                    balance: parseFloat(service.balance) || 0,
                    payment_method: service.payment_method || 'cash',
                    status: service.status || 'completed',
                    notes: service.notes || ''
                }));

                setCarSearchTerm(service.car_model || '');

                if (service.customer_id && service.customer_name) {
                    setSelectedCustomer({
                        customerid: service.customer_id,
                        customer_name: service.customer_name,
                        phone: service.customer_phone,
                        address: service.customer_address
                    });
                    setCustomerSearchTerm(service.customer_name);
                } else if (service.is_walking_customer) {
                    setSelectedCustomer({ customer_name: 'Walking Customer' });
                    setCustomerSearchTerm('Walking Customer');
                }

                if (service.services && service.services.length > 0) {
                    setServices(service.services.map((s, idx) => ({
                        serial_no: s.serial_no || idx + 1,
                        service_name: s.service_name,
                        charges: parseFloat(s.charges) || 0,
                        description: s.description || '',
                        employees: s.employees ? s.employees.map(e => e.employee_id) : [],
                        employee_details: s.employees ? s.employees.map(e => ({ 
                            employee_id: e.employee_id, 
                            employee_name: e.employee_name, 
                            salary_type: e.salary_type || 'task_based',
                            amount_paid: e.amount_paid || 0 
                        })) : []
                    })));
                }

                if (service.products && service.products.length > 0) {
                    setSelectedProducts(service.products.map(p => ({
                        product_id: p.product_id,
                        product_name: p.product_name,
                        product_code: p.product_code,
                        batch_no: p.batch_no,
                        quantity: parseFloat(p.quantity),
                        unit: p.unit,
                        unit_of_measure: p.unit_of_measure,
                        packing_type: p.packing_type,
                        items_per_pack: p.items_per_pack || 1,
                        price_per_unit: parseFloat(p.price_per_unit) || 0
                    })));
                }
            }
        } catch (error) {
            showToast('error', 'Failed to load service data');
        } finally {
            setLoading(false);
        }
    };

    const getNextServiceNumber = async () => {
        if (!shopId) return;
        try {
            const response = await fetch(SERVICE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_next_number', shop_id: shopId })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setFormData(prev => ({ ...prev, service_number: data.data.service_number }));
            }
        } catch (error) {
            console.error('Error getting service number:', error);
        }
    };

    useEffect(() => {
        if (shopId) {
            loadEmployees();
            loadCars();
            loadServicesList();
            fetchBusinessInfo();
            if (!isEditMode) getNextServiceNumber();
        }
    }, [shopId]);

    useEffect(() => {
        if (serviceId) {
            setIsEditMode(true);
            loadServiceData(serviceId);
        }
    }, [serviceId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (customerSearchRef.current && !customerSearchRef.current.contains(event.target)) setShowCustomerDropdown(false);
            if (productSearchRef.current && !productSearchRef.current.contains(event.target)) setShowProductDropdown(false);
            if (carSearchRef.current && !carSearchRef.current.contains(event.target)) setShowCarDropdown(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Load available shops for shop selector
    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                setAvailableShops([]);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', translations.shopSwitched || 'Shop switched successfully');
                setShowShopSelector(false);
            } else {
                showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
            }
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const handleClear = () => {
        if (isEditMode) return;
        setFormData({
            date: new Date().toISOString().split('T')[0],
            service_number: formData.service_number,
            car_model: '',
            car_number_plate: '',
            subtotal: 0,
            tax: 0,
            discount: 0,
            grand_total: 0,
            paid_amount: 0,
            balance: 0,
            payment_method: 'cash',
            status: 'pending',
            notes: '',
            themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
        });
        setServices([{ serial_no: 1, service_name: '', charges: 0, description: '', employees: [], employee_details: [] }]);
        setSelectedProducts([]);
        setSelectedCustomer(null);
        setCustomerSearchTerm('');
        setCarSearchTerm('');
        setErrors({});
        showToast('success', translations.clearForm || 'Form cleared');
        
        setTimeout(() => {
            if (customerSearchInputRef.current) {
                customerSearchInputRef.current.focus();
            }
        }, 100);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (services.length === 0) newErrors.services = translations.atLeastOneService || 'At least one service is required';
        services.forEach((service, idx) => {
            if (!service.service_name.trim()) newErrors[`service_name_${idx}`] = translations.serviceNameRequired || 'Service name is required';
            if (service.charges <= 0) newErrors[`charges_${idx}`] = translations.chargesRequired || 'Charges must be greater than 0';
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ==================== ✅ FIXED HANDLE SUBMIT ====================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSavingRef.current) {
            showToast('warning', translations.pleaseWait || 'Please wait, already processing...');
            return;
        }
        if (!currentShop) {
            showToast('error', translations.selectShopFirst || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }
        if (!validateForm()) {
            showToast('error', translations.fixErrors || 'Please fix the errors before submitting');
            return;
        }

        isSavingRef.current = true;
        setSaving(true);

        // ✅ CRITICAL FIX: Build employee_details with proper amount_paid from the form
        const servicesPayload = services.map(s => {
            // Get employee details from the service
            let employeeDetails = (s.employee_details || []).map(emp => {
                // Find the full employee data to get salary_type
                const empData = employees.find(e => e.employee_id === emp.employee_id);
                return {
                    employee_id: emp.employee_id,
                    employee_name: emp.employee_name || empData?.employee_name || '',
                    amount_paid: parseFloat(emp.amount_paid) || 0,
                    salary_type: empData?.salary_type || 'task_based'
                };
            });

            // If there are employees but no employee_details, create them from employees array
            if (s.employees && s.employees.length > 0 && employeeDetails.length === 0) {
                s.employees.forEach(empId => {
                    const empData = employees.find(e => e.employee_id === empId);
                    employeeDetails.push({
                        employee_id: empId,
                        employee_name: empData?.employee_name || '',
                        amount_paid: 0,
                        salary_type: empData?.salary_type || 'task_based'
                    });
                });
            }

            // ✅ Also ensure all employees in the employees array have entries in employee_details
            if (s.employees && s.employees.length > 0) {
                s.employees.forEach(empId => {
                    if (!employeeDetails.find(d => d.employee_id === empId)) {
                        const empData = employees.find(e => e.employee_id === empId);
                        employeeDetails.push({
                            employee_id: empId,
                            employee_name: empData?.employee_name || '',
                            amount_paid: 0,
                            salary_type: empData?.salary_type || 'task_based'
                        });
                    }
                });
            }

            return {
                service_name: s.service_name,
                description: s.description || '',
                charges: s.charges || 0,
                employees: s.employees || [],
                employee_details: employeeDetails
            };
        });

        const payload = {
            action: isEditMode ? 'edit' : 'add',
            shop_id: currentShop?.shop_id || shopId,
            username: user?.username || '',
            date: formData.date,
            customer_id: selectedCustomer?.customerid || null,
            customer_name: selectedCustomer?.customer_name || (customerSearchTerm === 'Walking Customer' ? 'Walking Customer' : ''),
            customer_phone: selectedCustomer?.phone || '',
            customer_address: selectedCustomer?.address || '',
            car_model: formData.car_model,
            car_number_plate: formData.car_number_plate,
            services: servicesPayload,
            products: selectedProducts.map(p => ({
                product_id: p.product_id,
                product_name: p.product_name,
                product_code: p.product_code || '',
                batch_no: p.batch_no || '',
                quantity: p.quantity,
                unit: p.unit,
                unit_of_measure: p.unit_of_measure,
                packing_type: p.packing_type,
                items_per_pack: p.items_per_pack || 1,
                price_per_unit: p.price_per_unit
            })),
            subtotal: formData.subtotal,
            tax: formData.tax,
            discount: formData.discount,
            grand_total: formData.grand_total,
            paid_amount: formData.paid_amount,
            payment_method: formData.payment_method,
            status: formData.status,
            notes: formData.notes,
            task_based_employee_total: calculateTaskBasedEmployeeTotal()
        };

        if (isEditMode && serviceId) payload.service_id = serviceId;

        // ✅ DEBUG: Log what we're sending
        console.log('📤 Sending payload:', JSON.stringify({
            ...payload,
            services: payload.services.map(s => ({
                ...s,
                employee_details: s.employee_details
            }))
        }, null, 2));

        try {
            const response = await fetch(SERVICE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            console.log('📦 Response from server:', data);

            if (data.status === 'success') {
                showToast('success', isEditMode ? translations.serviceUpdated || 'Service updated successfully!' : translations.serviceSaved || 'Service saved successfully!');
                
                // ✅ Check if task payments were recorded
                if (data.data?.task_payments_recorded && data.data.task_payments_recorded.length > 0) {
                    console.log('✅ Task payments recorded:', data.data.task_payments_recorded);
                    showToast('success', `✅ ${data.data.task_payments_recorded.length} employee payment(s) recorded (Total: ${data.data.task_based_payments || 0})`);
                } else {
                    console.warn('⚠️ No task payments recorded in response');
                    // Check if there were any task-based employees
                    const hasTaskBased = services.some(s => 
                        (s.employee_details || []).some(emp => {
                            const empData = employees.find(e => e.employee_id === emp.employee_id);
                            return empData?.salary_type === 'task_based' && parseFloat(emp.amount_paid) > 0;
                        })
                    );
                    if (hasTaskBased) {
                        showToast('warning', '⚠️ Service saved but no task payments were recorded. Please check employee salary type in database.');
                    }
                }
                
                if (!isEditMode) {
                    setServices([{ serial_no: 1, service_name: '', charges: 0, description: '', employees: [], employee_details: [] }]);
                    setSelectedProducts([]);
                    setSelectedCustomer(null);
                    setCustomerSearchTerm('');
                    setCarSearchTerm('');
                    setFormData(prev => ({ ...prev, car_model: '', car_number_plate: '', tax: 0, discount: 0, paid_amount: 0, payment_method: 'cash', notes: '' }));
                    getNextServiceNumber();
                }
                if (onSuccess) onSuccess(data.data?.service_id);
            } else {
                showToast('error', data.message || translations.failedSave || 'Failed to save service');
            }
        } catch (error) {
            console.error('❌ Error saving service:', error);
            showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            isSavingRef.current = false;
            setSaving(false);
        }
    };

    const taskBasedTotal = calculateTaskBasedEmployeeTotal();
    const netReceivable = formData.grand_total - taskBasedTotal;
    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozserui-container ${isRTL ? 'ozserui-rtl' : 'ozserui-ltr'} ${darkMode ? 'ozserui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <PaymentModal 
                showPaymentModal={showPaymentModal}
                setShowPaymentModal={setShowPaymentModal}
                translations={translations}
                services={services}
                selectedProducts={selectedProducts}
                formData={formData}
                taskBasedTotal={taskBasedTotal}
                netReceivable={netReceivable}
                handleChange={handleChange}
            />

            {/* Modern Animated Sticky Header */}
            <div className="ozserui-sticky-header">
                <div className="ozserui-header-bg-animation">
                    <div className="ozserui-gradient-orb ozserui-orb-1"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-2"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-3"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-4"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-5"></div>
                </div>
                <div className="ozserui-header-content">
                    <div className="ozserui-header-left">
                        <div className="ozserui-header-title">
                            <h1>{isEditMode ? (translations.editService || 'Edit Service') : (translations.newService || 'New Service')}</h1>
                            <p>{isEditMode ? (translations.editDesc || 'Update service details') : (translations.createDesc || 'Create and manage service requests')}</p>
                        </div>
                    </div>
                    
                    <div className="ozui-header-right">
                        {!currentShop && (
                            <button className="ozui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                        
                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>{translations.clear || 'Clear'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={saveDraft}
                                disabled={loading}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>
                            
                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>
                                
                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.formData?.service_number || translations.unnamedService || 'Unnamed Service'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.formData?.car_model && <span>{draft.formData.car_model}</span>}
                                                                {draft.formData?.car_number_plate && <span>{draft.formData.car_number_plate}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="ozserui-form">
                {/* First Row - Service Number, Date, Customer Search */}
                <div className="ozserui-form-row">
                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faHashtag} className="ozserui-input-icon" />
                            <input type="text" value={formData.service_number} readOnly placeholder=" " />
                            <label>Service Number</label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faCalendarDay} className="ozserui-input-icon" />
                            <input type="date" name="date" value={formData.date} onChange={handleChange} required placeholder=" " />
                            <label>Date *</label>
                        </div>
                    </div>

                    <div className="ozserui-customer-search-wrapper" ref={customerSearchRef}>
                        <div className="ozserui-field" style={{ flex: 1, margin: 0 }}>
                            <div className="ozserui-input-wrapper">
                                <FontAwesomeIcon icon={faSearch} className="ozserui-input-icon" />
                                <input
                                    ref={customerSearchInputRef}
                                    type="text"
                                    value={customerSearchTerm}
                                    onChange={(e) => {
                                        setCustomerSearchTerm(e.target.value);
                                        if (e.target.value && e.target.value !== 'Walking Customer') {
                                            searchCustomers(e.target.value);
                                        } else if (e.target.value === 'Walking Customer') {
                                            setSelectedCustomer({ customer_name: 'Walking Customer' });
                                            setShowCustomerDropdown(false);
                                        } else if (!e.target.value) {
                                            setSelectedCustomer(null);
                                        }
                                    }}
                                    onFocus={() => {
                                        if (customerSearchTerm && customerSearchTerm !== 'Walking Customer') {
                                            searchCustomers(customerSearchTerm);
                                        }
                                    }}
                                    placeholder=" "
                                    autoComplete="off"
                                />
                                <label>
                                    <FontAwesomeIcon icon={faUser} />
                                    {translations.searchCustomer || 'Search Customer'}
                                </label>
                            </div>
                            {showCustomerDropdown && customers.length > 0 && (
                                <div className="ozserui-customer-dropdown">
                                    <div className="ozserui-customer-item" onClick={() => {
                                        setSelectedCustomer({ customer_name: 'Walking Customer' });
                                        setCustomerSearchTerm('Walking Customer');
                                        setShowCustomerDropdown(false);
                                    }}>
                                        <div className="ozserui-customer-name">🚶 {translations.walkingCustomer || 'Walking Customer'}</div>
                                    </div>
                                    {customers.map(customer => (
                                        <div key={customer.customerid} className="ozserui-customer-item" onClick={() => selectCustomer(customer)}>
                                            <div className="ozserui-customer-name">{customer.customer_name}</div>
                                            {customer.phone && <div className="ozserui-customer-phone">{customer.phone}</div>}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Second Row - Car Model and Number Plate */}
                <div className="ozserui-form-row">
                    <div className="ozserui-field" ref={carSearchRef}>
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faCar} className="ozserui-input-icon" />
                            <input
                                type="text"
                                name="car_model"
                                value={formData.car_model}
                                onChange={(e) => {
                                    setFormData(prev => ({ ...prev, car_model: e.target.value }));
                                    setCarSearchTerm(e.target.value);
                                    if (e.target.value.length >= 2) {
                                        searchCars(e.target.value);
                                    } else {
                                        loadCars();
                                    }
                                }}
                                onFocus={() => {
                                    loadCars();
                                }}
                                placeholder=" "
                                autoComplete="off"
                            />
                            <label>
                                <FontAwesomeIcon icon={faCar} />
                                {translations.carModel || 'Car Model'}
                            </label>
                            {searchingCar && <FontAwesomeIcon icon={faSpinner} spin className="ozserui-search-spinner" />}
                        </div>
                        {showCarDropdown && cars.length > 0 && (
                            <div className="ozserui-customer-dropdown" style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000 }}>
                                {cars.map(car => (
                                    <div key={car.car_id} className="ozserui-customer-item" onClick={() => selectCar(car)}>
                                        <div className="ozserui-customer-name">{car.car_name}</div>
                                        {car.serial_number && <div className="ozserui-customer-phone" style={{ fontSize: '11px' }}>S/N: {car.serial_number}</div>}
                                    </div>
                                ))}
                            </div>
                        )}
                        {showCarDropdown && cars.length === 0 && !searchingCar && (
                            <div className="ozserui-customer-dropdown" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                <div className="ozserui-customer-item" style={{ color: '#999' }}>
                                    No cars found
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faTag} className="ozserui-input-icon" />
                            <input type="text" name="car_number_plate" value={formData.car_number_plate} onChange={handleChange} placeholder=" " />
                            <label>{translations.numberPlate || 'Number Plate'}</label>
                        </div>
                    </div>
                </div>

                {/* Services Section */}
                <div className="ozserui-services-header">
                    <button type="button" className="ozserui-add-service-icon-btn" onClick={addService}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>

                <div className="ozserui-services-list">
                    {services.map((service, idx) => (
                        <ServiceItem
                            key={idx}
                            service={service}
                            index={idx}
                            onUpdate={updateService}
                            onRemove={removeService}
                            employees={employees}
                            translations={translations}
                            errors={errors}
                            servicesList={servicesList}
                            loadingServices={searchingServicesList}
                        />
                    ))}
                </div>

                {/* Products Used Section */}
                <div className="ozserui-form-section">
                    <div className="ozserui-product-search-wrapper" ref={productSearchRef}>
                        <div className="ozserui-field">
                            <div className="ozserui-input-wrapper">
                                <FontAwesomeIcon icon={faSearch} className="ozserui-input-icon" />
                                <input
                                    type="text"
                                    value={productSearchTerm}
                                    onChange={(e) => {
                                        setProductSearchTerm(e.target.value);
                                        searchProducts(e.target.value);
                                    }}
                                    placeholder=" "
                                    autoComplete="off"
                                />
                                <label>
                                    <FontAwesomeIcon icon={faBarcode} />
                                    {translations.searchProducts || 'Search Products'}
                                </label>
                                {searchingProduct && <FontAwesomeIcon icon={faSpinner} spin className="ozserui-search-spinner" />}
                            </div>
                        </div>
                        {showProductDropdown && products.length > 0 && (
                            <div className="ozserui-product-dropdown">
                                {products.map(product => (
                                    <div key={product.id} className="ozserui-product-item" onClick={() => selectProduct(product)}>
                                        <div className="ozserui-product-name">{product.product_name}</div>
                                        <div className="ozserui-product-details">
                                            {product.product_code && <span>Code: {product.product_code}</span>}
                                            {product.batch_no && <span>Batch: {product.batch_no}</span>}
                                            <span>Stock: {product.quantity} packs</span>
                                        </div>
                                        <div className="ozserui-product-price">Rs. {product.sell_price_per_unit || product.sell_price}/unit</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {selectedProducts.length > 0 && (
                        <div className="ozserui-products-used-list">
                            {selectedProducts.map((product, idx) => (
                                <ProductUsed
                                    key={product.product_id || idx}
                                    product={product}
                                    index={idx}
                                    onUpdate={(index, key, value) => {
                                        if (key === 'quantity') updateProductQuantity(index, value);
                                    }}
                                    onRemove={removeProduct}
                                    translations={translations}
                                />
                            ))}
                        </div>
                    )}
                </div>

                {/* Form Actions */}
                <div className="ozserui-form-actions">
                    <button
                        type="button"
                        className="ozserui-action-btn"
                        onClick={handleDirectPrint}
                        style={{ background: 'var(--ozserui-primary)', color: 'white', padding: '0.5rem 1rem' }}
                    >
                        <FontAwesomeIcon icon={faPrint} />
                        <span>{translations.receipt || 'Receipt'}</span>
                    </button>

                    <button
                        type="button"
                        className="ozserui-action-btn"
                        onClick={() => setShowPaymentModal(true)}
                        style={{ background: 'var(--ozserui-primary)', color: 'white', padding: '0.5rem 1rem' }}
                    >
                        <FontAwesomeIcon icon={faPayment} />
                        <span>{translations.createPayment || 'Payment'}</span>
                    </button>

                    <button type="submit" className="ozserui-btn ozserui-btn-primary" disabled={saving || !currentShop}>
                        {saving ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{translations.saving || 'Saving...'}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} />
                                <span>{isEditMode ? (translations.updateService || 'Update Service') : (translations.createService || 'Save Service')}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>

            {loading && (
                <div className="ozserui-loading-overlay">
                    <div className="ozserui-loading-content">
                        <div className="ozserui-loading-spinner"></div>
                        <p>Loading service data...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceForm;